import EzController from 'controllers/ez-base-controller';
import { insertAjaxContent } from 'lib/ajax-helpers';
import { featureEnabled } from 'lib/helpers';

export default class RelatedGridsController extends EzController {
  static values = {
    resourceId: String,
    modalShowView: Boolean,
  }

  static targets = [
    'loadingSpinner',
  ];

  connect() {
    this.getRelatedGrids();
  }

  getRelatedGrids() {
    insertAjaxContent({
      url: `/resources/${this.resourceIdValue}/show_related_grids_async_content?modal_show_view=${this.modalShowViewValue}`,
      destElem: this.element,
      destPos: 'beforeend',
      successCb: () => {
        this.loadingSpinnerTarget.remove();

        this.pageGrids = this.element.querySelectorAll(
          '[data-controller*="resources-grid"]:not(.ez-resource-grid--partner)',
        );

        this.pageGrids.forEach((grid) => {
          this.updateGridItems(grid);
        });

        if (!featureEnabled('related_async_improvements')) this.initAds();
      },
    });
  }

  initAds() {
    if (typeof window.properSpaNewPage === 'undefined') return;

    const adTemplates = document.querySelector('[data-proper-ad-id]') !== null;

    if (adTemplates) window.properSpaNewPage();
  }

  updateGridItems(grid) {
    window.ezResourceGrid({
      gridSelector: grid,
      options: {
        truncate: !!grid.getAttribute('data-truncate-results'),
      },
    });
  }
}
